import React, { Component } from 'react';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';

class PaymentSuccess extends Component {
    constructor(props) {
        super(props);
        this.state = {
            transactionDetails: null,
            isLoading: false
        };
        this.toast = React.createRef();
    }

    componentDidMount() {
        this.extractTransactionDetails();
    }

    extractTransactionDetails = () => {
        try {
            const urlParams = new URLSearchParams(window.location.search);

            const transactionDetails = {
                status: urlParams.get('status'),
                txnId: urlParams.get('txnId'),
                atomTxnId: urlParams.get('atomTxnId'),
                amount: urlParams.get('amount'),
                date: urlParams.get('date'),
                mode: urlParams.get('mode'),
                bankTxnId: urlParams.get('bankTxnId')
            };

            console.log('Extracted transaction details:', transactionDetails);
            this.setState({ transactionDetails });
        } catch (error) {
            console.error('Error extracting transaction details:', error);
            this.showToast('error', 'Error', 'Failed to load transaction details');
        }
    };

    showToast = (severity, summary, detail) => {
        if (this.toast.current) {
            this.toast.current.show({ severity, summary, detail, life: 5000 });
        }
    };

    render() {
        const { transactionDetails } = this.state;

        if (!transactionDetails) {
            return (
                <div className="payment-success-container p-4">
                    <div className="flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
                        <div className="text-center">
                            <i className="pi pi-spin pi-spinner" style={{ fontSize: '2rem' }}></i>
                            <p className="mt-3">Loading transaction details...</p>
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div className="payment-success-container p-4">
                <Toast ref={this.toast} />

                <div className="flex justify-content-center">
                    <Card
                        title="Payment Successful!"
                        style={{ width: '600px' }}
                        className="border-success"
                    >
                        <div className="text-center mb-4">
                            <i className="pi pi-check-circle text-success" style={{ fontSize: '4rem' }}></i>
                            <h3 className="text-success mt-3">Your payment has been processed successfully</h3>
                            <p className="text-muted">Thank you for your payment. A confirmation email will be sent shortly.</p>
                        </div>

                        <div className="mt-4">
                            <h5 className="mb-3">Transaction Details</h5>
                            <DataTable value={[
                                { label: 'Transaction ID', value: transactionDetails.txnId || 'N/A' },
                                { label: 'Atom Transaction ID', value: transactionDetails.atomTxnId || 'N/A' },
                                { label: 'Amount', value: `₹${transactionDetails.amount || 'N/A'}` },
                                { label: 'Payment Mode', value: transactionDetails.mode || 'N/A' },
                                { label: 'Date & Time', value: transactionDetails.date ? new Date(transactionDetails.date).toLocaleString() : 'N/A' },
                                { label: 'Status', value: 'SUCCESS' }
                            ]} className="mt-2">
                                <Column field="label" header="Field" style={{ fontWeight: 'bold' }}></Column>
                                <Column field="value" header="Value"></Column>
                            </DataTable>
                        </div>
                    </Card>
                </div>
            </div>
        );
    }
}

export default PaymentSuccess;
